import { Component, OnInit, ElementRef } from '@angular/core';
import { IndicatorModalComponent } from '../IndicatorModal/IndicatorModal.component';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AChartComponent } from '../../achart/achart.component';
import { Workspace } from '../../../model/workspace.data';
import { IIndicator, IIndicatorInstance } from '../../achart/indicators';
import { FormGroup } from '@angular/forms';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';
import { WolfieContextMenuService } from '../../../services/wolfie-context-menu/wolfie-context-menu.service';


@Component({
  selector: 'mobile-indicator-modal',
  template: require('./mobile-indicator-modal.component.html'),
  styles: [require('./mobile-indicator-modal.component.css')]
})
export class MobileIndicatorModalComponent extends IndicatorModalComponent{

  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }
  constructor(public activeModal: NgbActiveModal, protected element: ElementRef, protected workspaceService: WorkspaceServiceService, protected contextMenu: WolfieContextMenuService) 
  { 
    super(activeModal, element);
  }

  finish()
  {
    this.contextMenu.hide();
    this.activeModal.close(this.form);
  }
}
